import { useEffect } from 'react';

/**
 * Shared hook to subscribe/unsubscribe to DDC pubsub topics.
 *
 * @param {string} topic - The pubsub topic to subscribe to
 * @param {Function} callback - The callback function to invoke on topic events
 * @param {boolean} isReady - Whether the hook should be active
 */
export const usePubsub = (topic, callback, isReady) => {
	useEffect(() => {
		if (!isReady) {
			return () => {};
		}

		const pubsub = window.DDC?.pubsub;
		if (pubsub) {
			pubsub.subscribe(topic, callback);
		}

		return () => {
			if (pubsub) {
				pubsub.unsubscribe(topic, callback);
			}
		};
	}, [topic, callback, isReady]);
};
